/* tslint:disable */
/* eslint-disable */
/**
 * Webclipping
 * WebclippingのAPI
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ArticlePastSearchReportChart,
    ArticlePastSearchReportChartFromJSON,
    ArticlePastSearchReportChartFromJSONTyped,
    ArticlePastSearchReportChartToJSON,
} from './ArticlePastSearchReportChart';

/**
 * 過去記事検索のグラフ
 * @export
 * @interface ArticlePastSearchSummary
 */
export interface ArticlePastSearchSummary {
    /**
     * excel_created_status
     * @type {number}
     * @memberof ArticlePastSearchSummary
     */
    excelCreatedStatus?: ArticlePastSearchSummaryExcelCreatedStatusEnum;
    /**
     * csv_created_status
     * @type {number}
     * @memberof ArticlePastSearchSummary
     */
    csvCreatedStatus?: ArticlePastSearchSummaryCsvCreatedStatusEnum;
    /**
     * 
     * @type {ArticlePastSearchReportChart}
     * @memberof ArticlePastSearchSummary
     */
    chart: ArticlePastSearchReportChart | null;
}

/**
* @export
* @enum {string}
*/
export enum ArticlePastSearchSummaryExcelCreatedStatusEnum {
    NONE = 0,
    CREATING = 1,
    CREATED = 2
}/**
* @export
* @enum {string}
*/
export enum ArticlePastSearchSummaryCsvCreatedStatusEnum {
    NONE = 0,
    CREATING = 1,
    CREATED = 2
}

export function ArticlePastSearchSummaryFromJSON(json: any): ArticlePastSearchSummary {
    return ArticlePastSearchSummaryFromJSONTyped(json, false);
}

export function ArticlePastSearchSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArticlePastSearchSummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'excelCreatedStatus': !exists(json, 'excel_created_status') ? undefined : json['excel_created_status'],
        'csvCreatedStatus': !exists(json, 'csv_created_status') ? undefined : json['csv_created_status'],
        'chart': ArticlePastSearchReportChartFromJSON(json['chart']),
    };
}

export function ArticlePastSearchSummaryToJSON(value?: ArticlePastSearchSummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'excel_created_status': value.excelCreatedStatus,
        'csv_created_status': value.csvCreatedStatus,
        'chart': ArticlePastSearchReportChartToJSON(value.chart),
    };
}

